import {useEffect, useMemo} from 'react';
import {usePreloadLivenessModels} from './hooks/usePreloadLivenessModels';
import {useReservation} from 'context/reservation';
import {canUseClientSideDetection} from 'components/LivenessDetection/utils/deviceCapabilities';
import {useLivenessModelsStore} from 'components/LivenessDetection/store';
import ChekinProSettings from 'ChekinProSettings';

export const LivenessModelPreloader = () => {
  const {housing} = useReservation();
  const setIsWebGLSupported = useLivenessModelsStore(state => state.setIsWebGLSupported);
  const forceLivenessMechanism = housing?.force_liveness_mechanism || 'AUTO';

  const isDeviceCapable = useMemo(() => {
    if (ChekinProSettings.isSDK) {
      return false;
    }

    if (forceLivenessMechanism === 'SERVER') {
      return false;
    }

    if (forceLivenessMechanism === 'CLIENT') {
      return true;
    }

    return canUseClientSideDetection({
      setIsWebGLSupported,
    });
  }, [setIsWebGLSupported, forceLivenessMechanism]);

  const {preload} = usePreloadLivenessModels();

  useEffect(() => {
    if (!housing?.id || !isDeviceCapable || forceLivenessMechanism === 'SERVER') {
      return;
    }

    if (housing.is_liveness_detection_enabled) {
      void preload();
    }
  }, [
    preload,
    housing?.id,
    isDeviceCapable,
    forceLivenessMechanism,
    housing?.is_liveness_detection_enabled,
  ]);

  return null;
};
